import { render, staticRenderFns } from "./wdsb.vue?vue&type=template&id=613ad33e&"
import script from "./wdsb.vue?vue&type=script&lang=js&"
export * from "./wdsb.vue?vue&type=script&lang=js&"
import style0 from "./wdsb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports